import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { forceScrollToTop } from "../utils/scrollUtils";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // If URL has a hash, scroll to that element
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    // Otherwise scroll to top
    forceScrollToTop();
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;